<button
  (click)="close()"
  class="close"
  disableRipple="true"
  mat-icon-button
  tabindex="1000"
  >
  <mat-icon>close</mat-icon>
</button>
<div #fullscreen class="fullscreen">
  <lib-image-loader
    [url]="
      currentPhoto$
        | async
        | getImageUrl
          : (currentPhoto$ | async).photoGroupId
          : 'anyone'
          : context
          : contextId
          : 2000
          : ((currentPhoto$ | async).photoGroupId
              | getGroupWatermarkHash: 'photographer')
          : false
        | async
    "
  ></lib-image-loader>
  <span (click)="next()" class="right"
    ><mat-icon>chevron_right</mat-icon></span
    >
    <span (click)="prev()" class="left"><mat-icon>chevron_left</mat-icon></span>
    <div class="footer">
      @if ((currentPhoto$ | async)?.label) {
        <h3 (click)="labelClickedAction()">{{(currentPhoto$ | async)?.label}}</h3>
      }
    {{currentIndex + 1}} / {{allPhotos.length}}</div>
  </div>
